import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer if present as a fallback (cookies may be blocked in some contexts)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Sprint 24 — carry the active Support Session so every request is
  // scoped to the impersonated tenant.
  const support = localStorage.getItem("gp_support_session");
  if (support) config.headers["X-Support-Session-Id"] = support;
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
